import { CancellationServiceAction } from "./types";

export const createCancellationTicket = () =>
  ({
    type: CancellationServiceAction.CREATE_CANCELLATION_TICKET,
  }) as const;

export const uploadImage = (payload) =>
  ({
    type: CancellationServiceAction.UPLOAD_IMAGE,
    payload,
  }) as const;

export const cleanUpstate = () =>
  ({
    type: CancellationServiceAction.CLEAN_UP,
  }) as const;

export const updateCancellationState = (payload) =>
  ({
    type: CancellationServiceAction.UPDATE_STATE,
    payload,
  }) as const;
